import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.linkTargets.forEach(link => {
      link.addEventListener('click', this.scrollToTarget.bind(this))
    })
  }

  scrollToTarget(event) {
    event.preventDefault()
    
    const targetId = event.currentTarget.getAttribute('href').substring(1)
    const targetElement = document.getElementById(targetId)
    const offset = parseInt(event.currentTarget.dataset.tocOffset, 10) || 0
    
    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    }
  }
}